import type { IRecaptchaAdapter, RecaptchaAdapterType } from './adapters/types';

export interface RecaptchaAdapterRegistryDebugInfo {
  hasAdapter: boolean;
  adapterType: RecaptchaAdapterType | null;
  isAvailable: boolean;
}

/**
 * RecaptchaAdapterRegistry - Runtime adapter selection registry
 *
 * Allows setting different reCAPTCHA token adapters based on platform:
 * - Web: WebRecaptchaAdapter (uses Google reCAPTCHA JS SDK)
 * - Mobile: MobileRecaptchaAdapter (uses @google-cloud/recaptcha-enterprise-react-native)
 * - Test: MockRecaptchaAdapter (for testing)
 */
class RecaptchaAdapterRegistry {
  private adapter: IRecaptchaAdapter | null = null;

  public setAdapter(adapter: IRecaptchaAdapter): void {
    this.adapter = adapter;
  }

  public getAdapter(): IRecaptchaAdapter | null {
    return this.adapter;
  }

  public hasAdapter(): boolean {
    return this.adapter !== null;
  }

  public clearAdapter(): void {
    this.adapter = null;
  }

  public getDebugInfo(): RecaptchaAdapterRegistryDebugInfo {
    return {
      hasAdapter: this.adapter !== null,
      adapterType: this.adapter?.adapterType ?? null,
      isAvailable: this.adapter?.isAvailable() ?? false,
    };
  }
}

export const recaptchaAdapterRegistry = new RecaptchaAdapterRegistry();
